<app-header></app-header>
<app-sidebar></app-sidebar>
<!-- <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "timer" [fullScreen] = "false"><p style="color: white" > 
    Loading... </p></ngx-spinner> -->

<div class="content-wrapper" style="min-height: 307px">

    <div class="row" *ngIf="editter">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <h1 class="">รายการคำขอแก้ไขข้อมูลแปลง</h1>
                </div>
                <div class="card-body">
                    <table class="table table-sm" #listplantedit>
                        <thead>
                            <tr>
                                <th scope="col">วันที่ขอ</th>
                                <th scope="col">ปี</th>
                                <th scope="col">เลขที่คำขอ</th>
                                <th scope="col">เลขแปลง</th>
                                <th scope="col">ชื่อ</th>
                                <th scope="col">เรื่องที่ขอ</th>
                                <th scope="col">สถานะ</th>
                                <th scope="col">หมายเหตุ</th>
                                <!-- <th scope="col">ความเห็นสินเชื่อ</th> -->
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of zonelist ; let i = index">
                                <td>{{item.date_add_th}} </td>
                                <td>{{item.year}}</td>
                                <td>{{item.edit_ID}}</td>
                                <td>{{item.intlandno}}</td>
                                <td>{{item.fmname}}</td>
                                <td>
                                    <p *ngIf="item.edit_type == 2"> {{item.edit_type_name}} จาก {{item.edit_from}} เป็น
                                        {{item.edit_to}}</p>
                                    <p *ngIf="item.edit_type != 2">{{item.edit_type_name}}</p>

                                    <p *ngIf="item.edit_type == 6"> จาก {{item.edit_from}} เป็น {{item.edit_code_to}} |
                                        {{item.edit_to}}</p>
                                </td>
                                <td>{{item.edit_status_doc}}</td>
                                <td><small class="text-danger">{{item.comment}}</small></td>
                                <!-- <td>{{item.comment3}}</td> -->
                                <td>
                                    <button (click)="openmodel(item.edit_ID);" type="button"
                                        class="btn  btn-sm btn-link" title="ข้อมูลเพิ่มเติม"><i class="fas fa-info"></i>
                                    </button>
                                    <button (click)="printForm(item.edit_ID);" type="button"
                                        class="btn  btn-sm btn-link" title="พิมพ์ฟอร์มขอแก้ไข">
                                        <i class="fas fa-print"></i>
                                    </button>
                                    <!-- <button class="btn btn-primary btn-sm" (click)="openmodel(item.edit_ID);">ตรวจสอบ</button> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="editter">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header bg-primary">คำร้องขอแก้ไขข้อมูลแปลง</div>
                <div class="card-body">
                    <table class="table table-sm" #listplantedit>
                        <thead>
                            <tr>
                                <th scope="col">วันที่ขอ</th>
                                <th scope="col">ปี</th>
                                <th scope="col">เลขที่คำขอ</th>
                                <th scope="col">เรื่องที่ขอ</th>
                                <th scope="col">สถานะ</th>
                                <th scope="col">หมายเหตุ</th>
                                <th scope="col">ความเห็นสินเชื่อ</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of acpzonelist">
                                <td>{{item.date_add_th}} </td>
                                <td>
                                    {{item.year}}
                                </td>
                                <td>{{item.edit_ID}}</td>
                                <td>
                                    <p *ngIf="item.edit_type == 2"> {{item.edit_type_name}} จาก {{item.edit_from}} เป็น
                                        {{item.edit_to}}</p>
                                    <p *ngIf="item.edit_type != 2">{{item.edit_type_name}}</p>

                                    <p *ngIf="item.edit_type == 6"> จาก {{item.edit_from}} เป็น {{item.edit_code_to}} |
                                        {{item.edit_to}}</p>
                                </td>
                                <td>{{item.edit_status_doc}}</td>
                                <td>{{item.comment}}</td>
                                <td>{{item.comment3}}</td>
                                <td>
                                    <button class="btn btn-primary" (click)="openmodelmanager(item.edit_ID);"
                                        data-bs-toggle="modal" data-bs-target="#explan_plant">
                                        เลือก
                                    </button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>

    <div class="modal fade" id="explan_plant" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>{{titletext}}</h3>
                    <button type="button" class="btn btn-sm btn-danger" data-bs-dismiss="modal" aria-label="Close"
                        (click)="closemodel();">ปิด X</button>
                </div>
                <div class="modal-body">
                    <div class="row" *ngFor="let item of oneselect">
                        <p>วันที่ขอ : {{item.date_add_th}} </p>
                        <p>
                            ปี : {{item.year}}
                        </p>
                        <p>เลขที่คำขอ : {{item.edit_ID}}</p>

                        <p *ngIf="item.edit_type == 2"> เรื่องที่ขอ : {{item.edit_type_name}} จาก {{item.edit_from}}
                            เป็น {{item.edit_to}}</p>
                        <p *ngIf="item.edit_type != 2"> เรื่องที่ขอ : {{item.edit_type_name}}</p>
                        <p *ngIf="item.edit_type == 6"> เรื่องที่ขอ : จาก {{item.edit_from}} เป็น {{item.edit_code_to}}
                            | {{item.edit_to}}</p>
                        <p *ngIf="userdata.userlevel === '12'">ความเห็นสินเชื่อ : {{item.comment3}}</p>
                        <p>หมายเหตุ : {{item.comment}}</p>
                    </div>
                    <div class="row" *ngIf="userdata.userlevel !== '15'">
                        <div class="col-md-12">
                            <form [formGroup]="Comment">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon1">หมายเหตุ</span>
                                    <input type="text" class="form-control" placeholder="กรุณาระบุ หากไม่มี ให้ใส่ -"
                                        formControlName="commentfinace">
                                </div>
                            </form>
                        </div>
                    </div>


                </div>
                <div class="modal-footer" *ngIf="userdata.userlevel == '10'">
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                        (click)="FinanceUnAccept(oneselect[0].edit_ID);">ไม่อนุมัติ</button>
                    <button type="button" class="btn btn-success"
                        (click)="FinanceAccept(oneselect[0].edit_ID);">อนุมัติ</button>
                </div>

                <div class="modal-footer" *ngIf="userdata.userlevel == '12'">
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                        (click)="managerUpdate(oneselect[0].edit_ID,2);">ไม่อนุมัติ</button>
                    <button type="button" class="btn btn-success"
                        (click)="managerUpdate(oneselect[0].edit_ID,1);">อนุมัติ</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="md_printForm" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>{{titletext}}</h3>
                    <button type="button" class="btn btn-sm btn-danger" data-bs-dismiss="modal" aria-label="Close"
                        (click)="closemodel();">ปิด X</button>
                </div>
                <div class="modal-body">
                    <div class="row" *ngFor="let item of datatoPrint">
                        <p>วันที่ขอ : {{item.date_add_th}}</p>
                        <p>เลขแปลง : {{item.intlandno}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!--  พิมพ์ฟอร์มขอแก้ไข -->
<div style="visibility: hidden;" id="formPrint">
    <div class="row">
        <div class="col">
            <img src="./assets/images/logo-bsf.png" alt="BSF LOGO">
            <p class="font-weight-bolder">แบบฟอร์มขอแก้ไขข้อมูลแปลงอ้อย ปี 2565/2566</p>
        </div>
    </div>
    <p class="text-center"> {{ time }}</p>
    <p *ngFor="let item of datatoPrint" class="text-center"> โควตา : {{item.fmcode}} : {{item.fmname}}</p>
</div>

<app-footer></app-footer>